import React from "react";

const entries = [
    {
        date: "March 23, 2026",
        title: "Smart Insights",
        items: [
            "Idle cash detection: flags excess checking balances and estimates what you'd earn in a high-yield savings account",
            "Recurring charge detection: finds subscriptions across all accounts with per-merchant amounts and annual totals",
            "Emergency fund analysis: alerts when your liquid savings fall below 3 months or exceed 8 months of expenses, including money market and treasury ETF positions",
            "Savings rate monitoring: notifies you when your savings rate drops and identifies the spending category responsible",
            "Every insight includes a dollar estimate so you know exactly what's at stake",
            "Dismiss insights you've already handled",
            "Insights refresh automatically with each account sync",
        ],
    },
    {
        date: "March 16, 2026",
        title: "Launch",
        items: [
            "Real-time net worth tracking across all financial institutions",
            "Automatic savings rate calculation with monthly trends",
            "FI number with customizable withdrawal rate",
            "Wealth projections powered by Monte Carlo simulation",
            "What-if scenario modeling for financial decisions",
            "Investment portfolio breakdown with holdings detail",
            "Financial goal tracking with automatic progress",
            "Spending breakdown by category",
            "Secure account connections through Plaid",
            "Two-factor authentication and device management",
        ],
    },
];

export default function ChangelogPage() {
    return (
        <div className="max-w-3xl mx-auto px-4 py-16">
            <div className="text-center mb-12">
                <h1 className="text-4xl font-bold text-gray-900 mb-4">Changelog</h1>
                <p className="text-gray-500">What's new in OmniWorth</p>
            </div>

            <div className="space-y-8">
                {entries.map((entry, i) => (
                    <div key={i} className="bg-white border border-gray-200 rounded-2xl shadow-sm p-8">
                        <span className="text-sm font-medium text-accent-600">{entry.date}</span>
                        <h2 className="text-xl font-bold text-gray-900 mt-1 mb-4">{entry.title}</h2>
                        <ul className="space-y-2">
                            {entry.items.map((item, j) => (
                                <li key={j} className="flex items-center gap-3">
                                    <span className="text-gray-500">•</span>
                                    <span className="text-gray-700 text-sm">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
}
